import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { InvestigationPage } from '@/features/ai-investigate/InvestigationPage'
import { useIsAdmin } from '@/lib/auth'

function AdminInvestigation() {
  const { id } = Route.useParams()
  const { run } = Route.useSearch()
  const isAdmin = useIsAdmin()
  const navigate = useNavigate()
  useEffect(() => {
    if (!isAdmin) navigate({ to: '/tickets' as never })
  }, [isAdmin, navigate])
  if (!isAdmin) return null
  return <InvestigationPage ticketId={id} runId={run} />
}

// Not nested under the ticket route: the investigation gets the full page width
export const Route = createFileRoute('/admin/tickets/$id_/investigation')({
  validateSearch: (search: Record<string, unknown>): { run?: string } => (typeof search.run === 'string' ? { run: search.run } : {}),
  component: AdminInvestigation
})
